<ng-container>
  <nz-select [ngModel]="value" [ngModelOptions]="{ standalone: true }" (ngModelChange)="writeValue($event)"
    nzMode="multiple" [nzDisabled]="disabled" [disabled]="disabled" (nzBlur)="onFieldBlur($event)">
    <nz-option *ngIf="enableCreateOption" nzValue="-100" [nzLabel]="'<Create New Option>' | locale">
    </nz-option>
    <ng-container *ngIf="dropDownsMetaData != null && dropDownsMetaData[field.Code] != null">
      <nz-option *ngFor="let option of dropDownsMetaData[field.Code]" [nzValue]="option.Code" [nzLabel]="option.Label">
      </nz-option>
    </ng-container>
  </nz-select>
</ng-container>

<nz-drawer *ngIf="addOptionDrawer" [nzVisible]="addOptionDrawer" nzWrapClassName="drawer-size-3x" nzClosable="false">
  <ng-container *nzDrawerContent>
    <form nz-form #optionForm="ngForm" (ngSubmit)="postOption(optionForm)">
      <nz-form-item>
        <nz-form-label nzRequired="true" nzFor="name">{{
          'Name' | translate | locale
          }}</nz-form-label>
        <nz-form-control>
          <input nz-input ngModel type="text" nzRequired="true" required name="name" />
        </nz-form-control>
      </nz-form-item>
      <ng-container *ngFor="let lang of languages">
        <nz-form-item *ngIf="lang.Code !== 0">
          <nz-form-label nzFor="{{ lang.Code }}">{{
            lang.Label
            }}</nz-form-label>
          <nz-form-control>
            <input nz-input ngModel type="text" name="{{ lang.Code }}" />
          </nz-form-control>
        </nz-form-item>
      </ng-container>
      <div>
        <nz-space>
          <button *nzSpaceItem nz-button nzType="primary" type="submit">
            {{'Submit' | translate}}
          </button>
          <button *nzSpaceItem nz-button type="button" (click)="addOptionDrawer = false">
            {{'Cancel' | translate}}
          </button>
        </nz-space>
      </div>
    </form>
  </ng-container>
</nz-drawer>
